import React, { useState } from "react";
import { useNeuroState, useDispatch } from "@ignitesales/neuro-application";
import { updateSubmittedProducts } from "../actions/commerce-business-branch-actions.mjs";


const useSubmittedProducts = () => {

  const dispatch = useDispatch();
  const { productCart, submittedProductsState = {} } = useNeuroState();
  const submittedIds = submittedProductsState?.submittedIds || [];


  const productWasSubmitted = (product, submittedIds) => submittedIds?.includes(product.id?.toString());


  const getNotSubmittedProducts = (products = [], submittedIds = []) => {
    return products.filter((product) => !submittedIds.includes(product.id?.toString()));
  }


  const saveSubmittedProducts = () => {
    if(productCart && submittedIds) {

      const idsToSave = [...new Set([...productCart, ...submittedIds])];
  
      // Save submitted products ids in answers 
      dispatch(updateSubmittedProducts(idsToSave));
    }    
  }


  return {
    productWasSubmitted,
    getNotSubmittedProducts,
    saveSubmittedProducts,
  }
}

export default useSubmittedProducts;